import React, { useEffect } from 'react';
import DirectToConsumerService from "../../services/DirectToConsumerService";
import { toast } from "react-toastify";
import { makeSerializable } from "../../utils/Utils";
import OrderHistoryData from "../../models/PackageOrderHistoryData";
import useD2C from "../../hooks/useD2C";
import Hero from "../registration/hero/Hero";
import Intro from "../registration/intro/Intro";

const tabs = {
    BILLING_HISTORY: 'billing_history',
    PACKAGES: 'packages'
}

const Plans = () => {
    const { handleIsD2CEnabled } = useD2C();

    useEffect(() => {
        const isRedirected = handleIsD2CEnabled();
        if(isRedirected) return;

        handleGetOrderHistory();
    }, []);

    const handleGetOrderHistory = async () => {
        let response = await DirectToConsumerService.orderHistory();
        let tempPackages = [];

        if(response.success) {
            tempPackages = response.data.map((packageData) => {
                return makeSerializable(new OrderHistoryData(packageData));
            })
        } else {
            toast.error("Internal Server Error, Please refresh the page");
        }
    }

    return (
        <>
            <Hero/>
            <Intro/>
        </>
    )
};

export default Plans;
